import React from 'react';
import { useLazyQuery } from '@common/hooks';
import { ErrorHandler } from '@common/components';
import {
  SSNQuery,
  SSNQueryArgs,
  SSNQueryResponse,
} from '@clinician-profile/graphql';

export const SsnLink = ({
  worksProfileId,
  canShowPhi,
}: {
  worksProfileId: string;
  canShowPhi: boolean;
}) => {
  const [getWorksProfileSsn, { error, data }] = useLazyQuery<
    SSNQueryResponse,
    SSNQueryArgs
  >(SSNQuery, {
    variables: {
      id: worksProfileId,
    },
  });

  if (!canShowPhi) {
    return null;
  }

  if (error) {
    return (
      <ErrorHandler error={error} log="SsnLink" messageType="contextual" />
    );
  }

  if (data) {
    return data.worksProfileSsn || 'N/A';
  }

  return <a onClick={() => getWorksProfileSsn()}>Show SSN</a>;
};
